import { PreviewFrame } from "./PreviewFrame";

const DAYS = [
  { label: "Mon", date: 1, today: false },
  { label: "Tue", date: 2, today: false },
  { label: "Wed", date: 3, today: false },
  { label: "Thu", date: 4, today: true }
];
const TIMES = ["9 AM", "10 AM", "11 AM"];

interface Appointment {
  col: number; // 1-based day index
  row: number; // 0-based time slot
  rowSpan: number; // height multiplier
  name: string;
  property: string;
  time: string;
}

const APPOINTMENTS: Appointment[] = [
  {
    col: 2,
    row: 1,
    rowSpan: 1,
    name: "Krista Stamm-Hirthe",
    property: "Lemongrow Apartments",
    time: "10 AM — 11 AM"
  },
  {
    col: 2,
    row: 2,
    rowSpan: 1,
    name: "Freddie Schowalter",
    property: "Lemongrow Apartments",
    time: ""
  }
];

export const ShowingsPreview = () => (
  <PreviewFrame innerClassName="!h-[237px]">
    <div className="flex h-full w-full">
      {/* Time column */}
      <div className="flex w-[64px] shrink-0 flex-col border-r border-[#f2f2f2] pt-[54px]">
        {TIMES.map((time) => (
          <div
            key={time}
            className="flex h-[60px] shrink-0 items-start justify-end gap-1 px-2 pt-1"
          >
            <span className="text-[12px] font-medium leading-3 text-content-200">
              {time}
            </span>
          </div>
        ))}
      </div>

      {/* Day columns */}
      <div className="grid flex-1 grid-cols-4">
        {/* Header row */}
        {DAYS.map((day) => (
          <div
            key={day.label}
            className="flex h-[54px] items-center justify-center gap-1 border-b border-[#f2f2f2] px-2"
          >
            <span className="text-[12px] font-medium leading-5 text-[#53545c]">
              {day.label}
            </span>
            <span
              className={
                day.today
                  ? "flex h-5 w-5 items-center justify-center rounded bg-primary-500 text-[11px] font-bold text-white"
                  : "flex h-5 w-5 items-center justify-center text-[12px] font-medium text-[#53545c]"
              }
            >
              {day.date}
            </span>
          </div>
        ))}

        {/* Time slot grid */}
        {TIMES.map((time, rowIdx) =>
          DAYS.map((day, colIdx) => {
            const appointment = APPOINTMENTS.find(
              (a) => a.col === colIdx && a.row === rowIdx
            );
            return (
              <div
                key={`${time}-${day.label}`}
                className="relative h-[60px] border-b border-r border-[rgba(28,29,34,0.08)]"
                style={{
                  backgroundImage: appointment
                    ? undefined
                    : "repeating-linear-gradient(45deg, transparent 0 4px, rgba(28,29,34,0.04) 4px 5px)"
                }}
              >
                {appointment ? (
                  <div
                    className="absolute inset-x-0.5 inset-y-0.5 flex overflow-hidden rounded border border-alpha-40 bg-primary-20"
                    style={{
                      boxShadow:
                        "0 1px 3px rgba(28,29,34,0.1), 0 1px 2px rgba(28,29,34,0.06)"
                    }}
                  >
                    <span className="w-[3px] shrink-0 rounded-full bg-primary-500" />
                    <div className="flex flex-col gap-[2px] px-2 py-1.5 leading-none">
                      <span className="text-[10px] font-bold text-primary-700">
                        {appointment.name}
                      </span>
                      <span className="text-[10px] font-medium text-primary-700/50">
                        {appointment.property}
                      </span>
                      {appointment.time ? (
                        <span className="text-[10px] font-medium text-primary-700/50">
                          {appointment.time}
                        </span>
                      ) : null}
                    </div>
                  </div>
                ) : null}
              </div>
            );
          })
        )}
      </div>
    </div>
  </PreviewFrame>
);
